import { render, staticRenderFns } from "./SectionAge.vue?vue&type=template&id=392f6c96"
import script from "./SectionAge.vue?vue&type=script&lang=ts"
export * from "./SectionAge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports